export default __webpack_public_path__ + "static/media/Union.458a84c3.svg";